// ============================================================================
// MODULAR DESIGN PRINCIPLES (MANDATORY)
// ============================================================================
// This file strictly follows:
// 1. Single Responsibility Principle - Each component does ONE thing
// 2. Separation of Concerns - Logic separated from presentation
// 3. Modular Architecture - Independent, reusable components
//
// Refer to: docs/architecture/modular-design-standards.md
// ============================================================================

/**
 * System Prompt Management Service
 * 
 * API client for managing AI system prompts
 */

import { apiClient, API_ENDPOINTS } from '../config/api';

const BASE_URL = API_ENDPOINTS.SYSTEM_PROMPTS;

const systemPromptService = {
  /**
   * List all system prompts
   */
  listPrompts: async (includeInactive = false) => {
    const response = await apiClient.get(`${BASE_URL}?include_inactive=${includeInactive}`);
    return response.data;
  },

  /**
   * Get active system prompt
   */
  getActivePrompt: async () => {
    const response = await apiClient.get(`${BASE_URL}/active/current`);
    return response.data;
  },

  /**
   * Get specific system prompt
   */
  getPrompt: async (promptId) => {
    const response = await apiClient.get(`${BASE_URL}/${promptId}`);
    return response.data;
  },

  /**
   * Create new system prompt
   */
  createPrompt: async (promptData) => {
    const response = await apiClient.post(BASE_URL, promptData);
    return response.data;
  },

  /**
   * Update system prompt
   */
  updatePrompt: async (promptId, promptData) => {
    const response = await apiClient.put(`${BASE_URL}/${promptId}`, promptData);
    return response.data;
  },

  /**
   * Activate a system prompt
   */
  activatePrompt: async (promptId) => {
    const response = await apiClient.post(`${BASE_URL}/${promptId}/activate`);
    return response.data;
  },

  /**
   * Delete system prompt
   */
  deletePrompt: async (promptId) => {
    const response = await apiClient.delete(`${BASE_URL}/${promptId}`);
    return response.data;
  },

  /**
   * Test a system prompt
   */
  testPrompt: async (promptText, testMessage) => {
    const response = await apiClient.post(`${BASE_URL}/test`, {
      prompt_text: promptText,
      test_message: testMessage
    });
    return response.data;
  }
};

export default systemPromptService;
